"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDashboard = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 18 18",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M16,2 L16,4 L12,4 L12,2 L16,2 M6,2 L6,8 L2,8 L2,2 L6,2 M16,10 L16,16 L12,16 L12,10 L16,10 M6,14 L6,16 L2,16 L2,14 L6,14 M18,0 L10,0 L10,6 L18,6 L18,0 Z M8,0 L0,0 L0,10 L8,10 L8,0 Z M18,8 L10,8 L10,18 L18,18 L18,8 Z M8,12 L0,12 L0,18 L8,18 L8,12 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDashboard')(IconDashboard);